import React from "react";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import { Col, Modal, Row, Space, Form } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnInput from "../common/adnInput/AdnInput";
import { EmailValidation, NameValidation } from "./EmailListValidations";
import { Messages } from "../common/CommonMessages";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import { useTranslation } from "react-i18next";

function EmailListPageForm({
  data,
  setVisible,
  visible,
  handleForm,
  setEmailHandler,
  emailHandler,
  event,
  setEvent,
  deleteRecord,
  loading,
  submitLoading,
  dropdownOptions,
}) {
  const [form] = Form.useForm();
  const { confirm } = Modal;
  const { t } = useTranslation();
  const columns = [
    {
      title: t("emailList.columns.name"),
      dataIndex: "name",
      width: "30%",
      editable: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: t("emailList.columns.email"),
      dataIndex: "email",
      width: "50%",
      editable: true,
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: t("emailList.columns.actions"),
      key: "action",
      render: (record) => (
        <Space size="middle">
          <EditOutlined
            style={{ color: "black" }}
            onClick={() => {
              setVisible(true);
              setEmailHandler(record);
              form.setFieldsValue(record);
              setEvent("edit");
            }}
          />
          <DeleteOutlined
            style={{ color: "red" }}
            onClick={() => {
              confirm({
                title: Messages.DeleteQuestion,
                okText: t("emailList.buttons.yes"),
                okType: "danger",
                cancelText: t("emailList.buttons.no"),
                onOk() {
                  deleteRecord(record.id);
                },
                onCancel() {},
              });
            }}
          />
        </Space>
      ),
      width: "10%",
    },
  ];
  return (
    <>
      <AdnPageTitle title={t("emailList.title")} />
      <AdnCard loading={loading}>
        <Row>
          {t("emailList.messages.addEmailToGroups")}
          <Col span={24}>
            <AdnAddButton
              name={t("emailList.title")}
              handleClick={() => {
                setEvent("add");
                setVisible(true);
              }}
              style={{ float: "right", marginTop: "1%", marginBottom: "1%" }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              data={data}
              columns={columns}
              pagination={false}
              totalRecords={data.length}
            />
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={
          event === "add"
            ? t("emailList.modals.newEmail")
            : t("emailList.modals.editEmail")
        }
        open={visible}
        onOk={form.submit}
        cancelText={t("emailList.buttons.cancel")}
        okText={t("emailList.buttons.save")}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        confirmLoading={submitLoading}
      >
        <Form
          form={form}
          name="form_in_modal"
          layout="vertical"
          onFinish={handleForm}
          initialValues={{ name: null, email: null }}
        >
          <AdnDropdown
            name={"name"}
            label={t("emailList.labels.name")}
            type="text"
            placeholder={t("emailList.placeholders.selectName")}
            options={dropdownOptions}
            rules={NameValidation}
            valueIsId={false}
            disabled={event === "add" ? false : true}
          />
          <AdnInput
            name={"email"}
            label={t("emailList.labels.email")}
            type={"email"}
            placeholder={t("emailList.placeholders.insertEmail")}
            rules={EmailValidation}
          />
        </Form>
      </Modal>
    </>
  );
}

export default EmailListPageForm;
